// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"28701ef0","98":"5f5b9a41","292":"755f6acd","409":"a33be5e7","620":"0594fb60","721":"04eb72d8","819":"a33be5e7"}[chunkId] + ".chunk.css";
};